import React from 'react';
import { connect } from 'react-redux';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { LogoPaysystem } from 'apps/auth/components/form/styles';
import { URL_IMAGES_PAYSYSTEMS } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { CvvContainer, DigitsGroup, DigitsRow, TextContainer } from './styles';

const CardInfo = (props) => {
    const { card, showMode } = props;
    const { cardExpDate, copied, CardNumberCopyMessage, CardHolderCopyMessage, ExpiryDateCopyMessage, CvvCopyMessage } = usePageMessages();

    const onCopyHandler = (e, message, value) => {
        if (showMode) {
            e.clipboardData.setData('text/plain', value);
            e.preventDefault();
            props.toggleSnackBar(true, `${message} ${copied}`);
        }
    };
    const cardNumber = showMode ? card.number : card.number.substring(0, 6) + '••••••' + card.number.substring(12);
    const cvv = showMode ? card.cvc : '•••';
    const exp = showMode ? card.expiredDate : '••/••';

    const getCardInfoColor = () => {
        if (card.plastic && showMode) {
            return 'white';
        } else if (card.plastic && !showMode) {
            return 'whiteRgba40';
        } else if (!card.plastic && !showMode) {
            return 'lightGray';
        }
    };

    return (
        <>
            <DigitsRow isPlastic={card.plastic} onCopy={(e) => onCopyHandler(e, CardNumberCopyMessage, card.number)}>
                <DigitsGroup isPlastic={card.plastic}>{cardNumber.slice(0, 4)}</DigitsGroup>
                <DigitsGroup isPlastic={card.plastic}>{cardNumber.slice(4, 8)}</DigitsGroup>
                <DigitsGroup isPlastic={card.plastic}>{cardNumber.slice(8, 12)}</DigitsGroup>
                <DigitsGroup isPlastic={card.plastic}>{cardNumber.slice(12, 16)}</DigitsGroup>
            </DigitsRow>
            <Row flex align="end" justify="between">
                <div>
                    <TextContainer isPlastic={card.plastic}>
                        <Text
                            color={card.plastic ? 'whiteRgba40' : 'lightGray'}
                            variant="div"
                            size="subheader"
                            indent="adaptive-8-16"
                            onCopy={(e) => onCopyHandler(e, CardHolderCopyMessage, card.cardHolderName)}
                        >
                            {card.cardHolderName}
                        </Text>
                    </TextContainer>
                    <Row flex>
                        <TextContainer isPlastic={card.plastic}>
                            <Text variant="span" size="subheader" color={card.plastic ? 'whiteRgba40' : 'lightGray'}>
                                {cardExpDate}&nbsp;
                                <Text
                                    size="subheader"
                                    color={getCardInfoColor()}
                                    onCopy={(e) => onCopyHandler(e, ExpiryDateCopyMessage, card.expiredDate?.replace('/', ''))}
                                >
                                    {exp}
                                </Text>
                            </Text>
                        </TextContainer>
                        <CvvContainer isPlastic={card.plastic}>
                            <Text variant="span" size="subheader" color={card.plastic ? 'whiteRgba40' : 'lightGray'}>
                                CVV&nbsp;
                                <Text size="subheader" color={getCardInfoColor()} onCopy={(e) => onCopyHandler(e, CvvCopyMessage, card.cvc)}>
                                    {cvv}
                                </Text>
                            </Text>
                        </CvvContainer>
                    </Row>
                </div>
                <LogoPaysystem>
                    {card.paySystem && card.paySystem.length > 0 && card.paySystem !== 'other' && (
                        <img src={`${URL_IMAGES_PAYSYSTEMS}/${card.paySystem}${card.plastic ? '_white' : ''}.svg`} alt={card.paySystem} />
                    )}
                </LogoPaysystem>
            </Row>
        </>
    );
};
export default connect(null, { toggleSnackBar })(CardInfo);
